// extracted by mini-css-extract-plugin
module.exports = {"type-rectangle":"_1GZt3","typeRectangle":"_1GZt3","text":"_1bpIr","details":"_1aEon","button":"_2ltbM","complex-type":"_26Uzy","complexType":"_26Uzy"};